import { createAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { RootState } from "./types";

export const hydrate = createAction<RootState>(HYDRATE);

export const authExpired = createAction("authExpired");

export const logout = createAction("logout");
